







































































import { Component, Prop, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { BPopover } from "bootstrap-vue";

@Component({
  components: {
    BPopover,
  },
  computed: mapState("gaps", ["status"]),
})
export default class StatusFilter extends Vue {
  id = "status-filter-popover";
  target = "status-filter-target";
  status!: Array<any>;
  list = Array<any>();
  checkStatus() {
    this.list.forEach((s) => {
      s.checked = true;
    });
  }
  uncheckStatus() {
    this.list.forEach((s) => {
      s.checked = false;
    });
  }
  get checkedStatus(): Array<any> {
    return this.list
      .filter((s) => {
        return s.checked;
      })
      .map((s) => s.id);
  }
  search() {
    const filter = JSON.parse(JSON.stringify(this.checkedStatus));
    this.$store.commit("gaps/SET_STATUS_FILTER", filter);
    this.close();
  }
  clear() {
    this.uncheckStatus();
    this.search();
  }
  close() {
    this.$root.$emit("bv::hide::popover", this.id);
    this.$emit("closed");
  }
  mounted() {
    const { statusList } = this.$store.state.gaps.filter;
    this.list = JSON.parse(JSON.stringify(this.status)).map((s) => {
      s.checked = statusList.includes(s.id);
      return s;
    });
  }
}
